module.exports = __webpack_public_path__ + "static/media/usdc.89f4dde2.svg";